import React, {Component} from 'react';
import {Link} from "react-router-dom";
import Footer from '../Footer';

class HomePage extends Component<{},{}>{

    constructor(props: any){
        super(props);
        this.state = {
        }; 
    }

    render(){
        return (
            <div id="home-page">
            <header>
                <ul>
                    <li><Link className="selected" to="/Home">Home</Link></li>
                    <li><Link to="/PrivacyPolicy">Privacy Policy</Link></li>
                    <li><Link to="/AboutUs">About Us</Link></li>
                    <li><Link to="/SummerDash">Summer Dash</Link></li>
                </ul>
            </header>
            <body>
                <div className="section"> 
                    Cockpit [When Chickens Fly] 
                    <a id="mainImg" href="https://www.youtube.com/watch?v=Sif6l_jg9Po" style={{backgroundImage:"url(/images/chicken.png)"}}>mainImage</a>
                    
                    <ul className="downloads">
                        <li><a id="image" href="https://apps.apple.com/us/app/cockpit-when-chickens-fly/id1533454862" 
                            style={{backgroundImage:"url(/images/IOS_Website.png)"}}>IOS</a></li>
                        <li><a id="image" href="https://play.google.com/store/apps/details?id=com.tanusoft.spacechicken" 
                            style={{backgroundImage:"url(/images/Android_Website.png)"}}>ANDROID</a></li>
                    </ul>
                </div>

            </body>
            <Footer></Footer>
            </div>
        )
    }
}

export default HomePage;